import componentSection from '../../../../LeftPane/componentSection';
import updateExportPrefs from '../../../../LeftPane/updateExportPrefs';

export default (type, userResumePreferences, text, setUserPreferences) => {
  const section = componentSection[type];
  let sectionIndex = 0;
  let requiredUserPref = userResumePreferences.leftPane.used[sectionIndex];
  userResumePreferences.leftPane.used.some((usedSection, index) => {
    sectionIndex = index;
    requiredUserPref = usedSection;
    if (usedSection.title === section) return usedSection;
    return false;
  });
  if (!text) {
    updateExportPrefs({
      type,
      sectionIndex,
      requiredUserPref,
      userResumePreferences,
      setUserPreferences,
      exportStatus: false,
    });
  } else if (!requiredUserPref.toExport[type]) {
    updateExportPrefs({
      type,
      sectionIndex,
      requiredUserPref,
      userResumePreferences,
      setUserPreferences,
      exportStatus: true,
    });
  }
};
